//* Importing Libraries
import React,  { useState ,useEffect} from "react";
//* Importing moment
import moment from "moment";

//* Importing Components from Material UI
import { CircularProgress } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

//* Importing Components
import { Alert } from "./alert";
import { Searchbar } from "./searchbar";
import { Actions } from "./actions";
import { Header } from "./header";

//* Importing Components from React Bootstrap
import { Button, Form } from "react-bootstrap";

//* Importing Icons
import { RiArrowGoBackLine } from "react-icons/ri";

//* Importing Components
import DefaultButton from "../base/DefaultButton";

//* Importing Hooks from React Router
import { useLocation, useNavigate } from "react-router-dom";

//* Importing useSelector from React Redux
import { useSelector } from "react-redux";

export function List(props: {
  show_warning: any;
  title: string;
  button_text?: string;
  button_link?: string;
  search_text?: string;
  deleting_message?: string;
  not_found_message: string;
  search_input_value: any;
  additionalButtons?: any[];
  additionalFilters?: React.ReactNode;
  onDeleteCancel?: () => any;
  onDeleteConfirm?: () => any;
  loading_screen: boolean;
  fields: any[];
  loading_search: boolean;
  items: any[];
  onDeleteActionClick?: (id: any) => void;
  onEditActionClick?: (id: any) => void;
  onManagerActionClick?: (id: any, params?: any) => void;
  onAuxiliar1ActionClick?: (id: any, params?: any) => void;
  onPermissionActionClick?: (id: any, params?: any) => void;
  pronoun?: string;
  pagination: { last_page: number; current_page: number };
  onChangePagination: (page: number) => void;
  onSearchButtonClick: () => void;
  onChangeSearchInput: (value: string) => void;
  onClickButton?: any;
  hideManager?: boolean;
  showAuxiliar1?: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
  hide_margin?: boolean;
  showPermissions?: boolean;
  // Props para recurso de seleção
  enableSelection?: boolean; // habilita ou não modo de seleção
  onSelectedItemsChange?: (selectedItems: any[]) => void; // callback quando há mudança na seleção
  customButton?: React.ReactNode; // botão customizado para apresentar
  selectedItemsCount?: number; // contagem externa de itens selecionados
  clearSelectionTrigger?: boolean;
}) {
  const [image, setImage] = useState("");
  const [toggled, setToggled] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const { me } = useSelector((store: any) => store.auth);
  const navigate = useNavigate();
  const location = useLocation();

  // Estado local para os itens selecionados
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  // Seleciona/deseleciona um item individual
  const handleSelectItem = (
    itemId: any,
    isChecked: boolean,
    canSelect: boolean = true
  ) => {
    if (!canSelect) return;

    let newSelectedItems = [...selectedItems];
    if (isChecked) {
      newSelectedItems.push(itemId);
    } else {
      newSelectedItems = newSelectedItems.filter((id) => id !== itemId);
    }
    setSelectedItems(newSelectedItems);

    if (props.onSelectedItemsChange) {
      props.onSelectedItemsChange(newSelectedItems);
    }
  };

  // Botão: Selecionar todos os itens que podem ser selecionados (ex: inativos)
  const handleSelectAllInativos = () => {
    // Filtra só os itens que têm canSelect = true
    const selectableIds = props.items
      .filter((item) => item.canSelect !== false)
      .map((item) => item.id);

    setSelectedItems(selectableIds);

    if (props.onSelectedItemsChange) {
      props.onSelectedItemsChange(selectableIds);
    }
  };

  // Botão: Desmarcar todos
  const handleDeselectAll = () => {
    setSelectedItems([]);
    if (props.onSelectedItemsChange) {
      props.onSelectedItemsChange([]);
    }
  };

  // Efeito que zera a seleção sempre que a prop clearSelectionTrigger muda
  useEffect(() => {
    if (props.clearSelectionTrigger !== undefined) {
      setSelectedItems([]);
    }
  }, [props.clearSelectionTrigger]);

  return (
    <div className={props.hide_margin ? "" : "col-12"}>
      <div className={props.hide_margin ? "" : "py-5 px-3"}>
        <div className={props.hide_margin ? "" : "card-body"} id="card">
          {/* Cabeçalho (se não estiver em hide_margin) */}
          {!props.hide_margin && (
            <Header pronoun={props.pronoun} title={props.title} />
          )}

          {/* Se o modo de seleção está habilitado, exiba contador de selecionados */}
          {props.enableSelection && (
            <div className="mb-2">
              <strong>
                Selecionados: {props.selectedItemsCount ?? selectedItems.length}
              </strong>
            </div>
          )}

          <Alert
            title="Atenção"
            text={props.deleting_message}
            show_warning={props.show_warning}
            onCancel={props.onDeleteCancel}
            onConfirm={props.onDeleteConfirm}
          />

          {/* Linha com botões adicionais + botões de seleção/deseleção */}
          <div className="row mb-3">
            <div className="col d-flex align-items-center flex-wrap gap-2">
              {/* Botões adicionais passados via props */}
              {props.additionalButtons?.map((item) => (
                <Button
                  key={item.label}
                  variant="success"
                  onClick={(e) => item.eventHandler(e)}
                  className="d-flex align-items-center"
                >
                  {item.label}
                </Button>
              ))}

              {/* Caso a seleção esteja habilitada, mostramos os botões de Selecionar e Desmarcar */}
              {props.enableSelection && (
                <>
                  <Button
                    variant="primary"
                    className="d-flex align-items-center"
                    onClick={handleSelectAllInativos}
                  >
                    Selecionar todos inativos
                  </Button>

                  <Button
                    variant="outline-secondary"
                    className="d-flex align-items-center"
                    onClick={handleDeselectAll}
                  >
                    Desmarcar todos
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center mb-3">
                {/* Barra de Pesquisa */}
                <Searchbar
                  search_input_value={props.search_input_value}
                  button_text={props.button_text}
                  button_link={props.button_link}
                  search_text={props.search_text}
                  onClickButton={props.onClickButton}
                  onChangeSearchInput={(value: any) =>
                    props.onChangeSearchInput(value)
                  }
                  onSearchButtonClick={() => props.onSearchButtonClick()}
                  additionalFilters={props.additionalFilters}
                  customButton={props.customButton}
                  enableSelection={props.enableSelection}
                  selectedItemsCount={
                    props.selectedItemsCount ?? selectedItems.length
                  }
                />
              </div>

              {!props.loading_screen && (
                <div>
                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                      style={{
                        border: "1px solid #d6d6d6",
                        borderRadius: "0.5rem",
                      }}
                    >
                      <table
                        id="tech-companies-1"
                        className={
                          props.hide_margin
                            ? "table table-striped"
                            : "table table-hover"
                        }
                        style={{
                          borderRadius: "2rem",
                        }}
                      >
                        <thead>
                          <tr>
                            {props.enableSelection && <th></th>}

                            {props.fields.map((field: any, idx: number) => (
                              <th key={idx}>{field.header}</th>
                            ))}

                            {(!props.hideManager ||
                              !props.hideDelete ||
                              !props.hideEdit ||
                              props.showAuxiliar1 ||
                              props.showPermissions) && (
                              <th data-priority="3">Ações</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {!props.loading_search &&
                            props.items?.map(
                              (
                                item: {
                                  [x: string]:
                                    | moment.MomentInput
                                    | boolean
                                    | undefined;
                                  id: any;
                                  canSelect?: boolean;
                                },
                                index: number
                              ) =>
                                item !== undefined && (
                                  <tr key={index}>
                                    {props.enableSelection && (
                                      <td>
                                        <Form.Check
                                          type="checkbox"
                                          checked={selectedItems.includes(
                                            item.id
                                          )}
                                          disabled={item.canSelect === false}
                                          onChange={(e) =>
                                            handleSelectItem(
                                              item.id,
                                              e.target.checked,
                                              item.canSelect !== false
                                            )
                                          }
                                        />
                                      </td>
                                    )}

                                    {props.fields.map(
                                      (
                                        field: {
                                          type: string;
                                          name: string | number;
                                          render?: (
                                            item: any
                                          ) => React.JSX.Element;
                                        },
                                        field_id: number
                                      ) => {
                                        let fieldParts = field.name
                                          .toString()
                                          .split(".");
                                        let itemValue: any = item;

                                        fieldParts.forEach((part) => {
                                          itemValue = itemValue[part] ?? "-";
                                        });

                                        if (
                                          field.type === "custom" &&
                                          field.render
                                        ) {
                                          return (
                                            <td key={field_id}>
                                              {field.render(item)}
                                            </td>
                                          );
                                        }

                                        if (field.type === "text") {
                                          return (
                                            <td key={field_id}>
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    itemValue?.toString() ?? "",
                                                }}
                                              />
                                            </td>
                                          );
                                        }

                                        if (field.type === "date") {
                                          return (
                                            <td key={field_id}>
                                              {itemValue &&
                                              moment(itemValue).isValid()
                                                ? moment(itemValue).format(
                                                    "DD/MM/YYYY HH:mm"
                                                  )
                                                : "-"}
                                            </td>
                                          );
                                        }

                                        return (
                                          <td key={field_id}>
                                            [undefined type]
                                          </td>
                                        );
                                      }
                                    )}

                                    {(!props.hideManager ||
                                      !props.hideDelete ||
                                      !props.hideEdit ||
                                      props.showPermissions ||
                                      props.showAuxiliar1) && (
                                      <td>
                                        <Actions
                                          actionItem={item}
                                          onEditClick={() => {
                                            if (props.onEditActionClick)
                                              props.onEditActionClick(item.id);
                                          }}
                                          onDeleteClick={() => {
                                            if (props.onDeleteActionClick)
                                              props.onDeleteActionClick(
                                                item.id
                                              );
                                          }}
                                          onManagerClick={() => {
                                            if (props.onManagerActionClick)
                                              props.onManagerActionClick(
                                                item.id,
                                                item
                                              );
                                          }}
                                          onAuxiliar1Click={() => {
                                            if (props.onAuxiliar1ActionClick)
                                              props.onAuxiliar1ActionClick(
                                                item.id
                                              );
                                          }}
                                          onPermissionClick={() => {
                                            if (props.onPermissionActionClick)
                                              props.onPermissionActionClick(
                                                item.id
                                              );
                                          }}
                                          showPermissions={
                                            props.showPermissions
                                          }
                                          showAuxiliar1={props.showAuxiliar1}
                                          hideManager={props.hideManager}
                                          hideEdit={props.hideEdit}
                                          hideDelete={
                                            props.hideDelete ||
                                            item.id === me.id
                                          }
                                        />
                                      </td>
                                    )}
                                  </tr>
                                )
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {props.loading_search && (
                    <div className="row" style={{ margin: 0 }}>
                      <div className="col-12 d-flex justify-content-center align-items-center">
                        <CircularProgress />
                      </div>
                    </div>
                  )}

                  {!props.loading_search && props.items?.length === 0 && (
                    <div className="row w-100">
                      <div className="col-12">
                        <p
                          style={{
                            textAlign: "center",
                            margin: "2vh 0",
                            fontWeight: "normal",
                          }}
                        >
                          {props.not_found_message}
                        </p>
                      </div>
                    </div>
                  )}

                  <br />

                  <Pagination
                    className={props.pagination.last_page === 1 ? "hide" : ""}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                    count={props.pagination.last_page}
                    page={props.pagination.current_page}
                    onChange={(_, page) => {
                      props.onChangePagination(page);
                    }}
                  />

                  {props.hide_margin === false &&
                    (location.pathname.match(/\//g) || []).length > 1 && (
                      <DefaultButton
                        bg="secondary"
                        text="Voltar"
                        icon={<RiArrowGoBackLine />}
                        onClick={() => {
                          navigate(-1);
                          return undefined;
                        }}
                      />
                    )}
                </div>
              )}

              {props.loading_screen && (
                <div className="row">
                  <div
                    className="col-12 d-flex justify-content-center align-items-center"
                    style={{ marginTop: "2rem" }}
                  >
                    <CircularProgress />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
